import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'

import * as kardexActions from 'action/kardex'
import * as reportActions from 'action/report'

import CommonReport from 'component/commonReport/CommonReport'
import columns from 'component/report/kardex/columns'
import fields from 'component/report/kardex/fields'
import applyMask from 'component/report/utils/Formatter'
import ReportDetails from 'component/report/kardex/ReportDetails/ReportDetails'

const KARDEX_CSV = 11

Kardex.propTypes = {
  auth: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  fetchKardex: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
  fetchReports: PropTypes.func.isRequired,
}

function Kardex(props) {
  const {
    auth: {
      user: { dsToken },
    },
    auth: { user },
    count,
    translate,
    fetchKardex,
    fetchReports,
  } = props

  const [formData, setFormData] = useState({})
  const [reportDetails, setReportDetails] = useState({})

  const isReportDetailsVisible = reportDetails.cdLm && reportDetails.dsLm

  async function onExport(callback) {
    await fetchReports(dsToken, { tpReport: KARDEX_CSV }, formData)

    const callbackReturn = true
    callback(callbackReturn)
  }

  function onSubmit(paramsDataFormFields, setResponseInTable) {
    fetchKardex(
      dsToken,
      paramsDataFormFields,
      (reportData) => {
        setResponseInTable(
          formatResponseToAddInTable(reportData.contentPaginated.kardexPojoList)
        )

        setResponseInReportDetails(
          formatResponseToAddInReportDetails(reportData)
        )

        setDataFormFields(paramsDataFormFields)
      },
      () => {
        setResponseInTable({})
        setDataFormFields({})
        setResponseInReportDetails({})
      }
    )
  }

  function setDataFormFields(paramsDataFormFields) {
    const formDataFields = {
      cdLm: paramsDataFormFields.cdLm,
      dtRef: paramsDataFormFields.dtRef,
      idBranch: paramsDataFormFields.idBranch,
      tpStatus: '',
      dsSectionLabel: translate('kardex.section'),
      dsStockStartOfMonthLabel: translate('kardex.stockStartOfMonth'),
      dsStockEndOfMonthLabel: translate('kardex.stockEndOfMonth'),
    }

    setFormData(formDataFields)
  }

  function formatResponseToAddInTable(kardexReports) {
    const response = { total: count, data: [] }

    const kardexReportsFormated = []
    let i = 0

    for (const report of kardexReports || []) {
      kardexReportsFormated[i] = {}
      for (const c in columns) {
        const col = columns[c]
        if (col.render) {
          if (report[col.field] || report[col.field] === 0) {
            kardexReportsFormated[i][col.field] = applyMask(
              col.type,
              report[col.field],
              translate
            )
          } else {
            kardexReportsFormated[i][col.field] = '-'
          }
        }
      }
      i++
    }

    response.data = kardexReportsFormated
    return response
  }

  function setResponseInReportDetails(reportDetailsFormated) {
    setReportDetails(reportDetailsFormated)
  }

  function setReportDetailsComponent() {
    if (isReportDetailsVisible) {
      return (
        <ReportDetails
          cdLm={reportDetails.cdLm}
          dsLm={reportDetails.dsLm}
          qtStockStartOfMonth={reportDetails.qtStockStartOfMonth}
          qtStockEndOfMonth={reportDetails.qtStockEndOfMonth}
          dsStockStartOfMonthLabel={translate('kardex.stockStartOfMonth')}
          dsStockEndOfMonthLabel={translate('kardex.stockEndOfMonth')}
          dsAdditionalInfoLabel={translate('kardex.section')}
          cdAdditionalInfo={reportDetails.cdSection}
          dsAdditionalInfo={reportDetails.dsSection}
        />
      )
    }
    return ''
  }

  function formatResponseToAddInReportDetails(reportData) {
    const reportSearchedContentDetails =
      removeUnnecessaryInformationsInTableDetails(reportData)
    const reportContentDetails = {
      cdLm: reportSearchedContentDetails.contentPaginated.cdLm,
      cdSection: reportSearchedContentDetails.contentPaginated.cdSection,
      dsLm: reportSearchedContentDetails.contentPaginated.dsLm,
      dsSection: reportSearchedContentDetails.contentPaginated.dsSection,
      qtStockStartOfMonth:
        reportSearchedContentDetails.contentPaginated.qtStockStartOfMonth,
      qtStockEndOfMonth:
        reportSearchedContentDetails.contentPaginated.qtStockEndOfMonth,
    }
    return reportContentDetails
  }

  function removeUnnecessaryInformationsInTableDetails(reportContentDetails) {
    delete reportContentDetails.contentPaginated.kardexPojoList
    delete reportContentDetails.count
    delete reportContentDetails.counter
    delete reportContentDetails.current
    delete reportContentDetails.pages
    delete reportContentDetails.type

    return reportContentDetails
  }

  function translateFieldsToAddInForm(fields) {
    for (const field of fields) {
      field.label = translate(field.label)
      field.help_text = translate(field.help_text)
      field.error_text = translate(field.error_text)
    }

    return fields
  }

  return (
    <CommonReport
      title={translate('kardex.report.title')}
      defaultOrder='dtInventory'
      onExport={onExport}
      onSubmit={onSubmit}
      columns={columns}
      fields={translateFieldsToAddInForm(fields)}
      user={user}
      topLeftPart={setReportDetailsComponent}
      limit={9999}
      translate={translate}
      emptyReportMsg='kardex.not.found'
    />
  )
}

/* istanbul ignore next */
function mapStateToProps({ paginateReducer }) {
  return {
    count: paginateReducer.count,
    current: paginateReducer.current,
    pages: paginateReducer.pages,
  }
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...kardexActions, ...reportActions }, dispatch)
}

/* istanbul ignore next */
const KardexTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(Kardex)

/* istanbul ignore next */
export default connect(mapStateToProps, mapDispatchToProps)(KardexTranslated)

export { Kardex }
